import { Component, EventEmitter, Output, Input } from '@angular/core';
import { NotificationCountersService } from '../../../../../services/notification-counters.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'todo-advanced-filter',
  template: require('./todo-advanced-filter.component.pug'),
  styles: [require('./todo-advanced-filter.component.css').toString()],
})
export class TodoAdvancedFilterComponent {
  @Output()
  onUpdateClick = new EventEmitter<any>();

  @Input()
  searchFilter;

  @Input()
  loading;

  reviewsSub: Subscription;
  reviews = 0;

  // filterApplied: boolean = false;
  // isCollapsed: boolean = true;

  doableTypeOptions = [
    {
      id: 'Review',
      title: 'Reviews',
      icon: 'fas fa-clipboard-check',
      activeClass: 'badge-info bg-task',
    }
  ];
  notificationCounters = {};

  // -------------------------------------------------------------------
  constructor(
    private notificationCountersService: NotificationCountersService,
  ) {}

  // -------------------------------------------------------------------
  ngOnInit() {
    // this.doableTypes = this.searchFilter.types;

    this.reviewsSub = this.notificationCountersService.reviewsCount.subscribe(
      data => {
        this.reviews = data;
        this.doableTypeOptions.find(opt => opt.id === 'Review')['count'] = data;
      },
    );
  }

  // -------------------------------------------------------------------
  ngOnDestroy(): void {
    if (this.reviewsSub) this.reviewsSub.unsubscribe();
  }

  // -------------------------------------------------------------------
  ngAfterViewInit() {}

  // -------------------------------------------------------------------
  typeEnabled(type) {
    return this.searchFilter.types.includes(type.id);
  }

  // -------------------------------------------------------------------
  changeType(
    type: any,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) {
    const index = this.searchFilter.types.indexOf(type.id, 0);
    if (index > -1) {
      this.searchFilter.types.splice(index, 1);
    } else {
      this.searchFilter.types.push(type.id);
    }

    this.apply();

    onsuccess();
  }

  // -------------------------------------------------------------------
  apply() {
    this.onUpdateClick.emit(this.searchFilter);
    // this.filterApplied = true;
  }
}
